<template>
  <div class="c-info">
    <o-icon v-if="icon !== null" class="c-info__icon" :icon="icon" />
    <slot />
  </div>
</template>

<script>
// @group Base Components
export default {
  props: {
    icon: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss">
.c-info {
  padding: 1.6rem;
  text-align: center;
}

.c-info__icon {
  background-color: rgba($primary-color, 0.1);
  border-radius: 3.2rem;
  display: inline-flex;
  height: 6.4rem;
  margin-bottom: 1.6rem;
  width: 6.4rem;

  svg {
    color: $primary-color;
    height: 3.2rem;
    margin: auto;
    width: 3.2rem;
  }
}
</style>
